module.exports = __webpack_public_path__ + "e7df903066c2b89c07eb378f5def99f9.svg";